<template>
    <div class="section">
        <h2 class="subtitle is-size-4">Loginoplysninger</h2>

        <form @submit.prevent="submit">
            <b-notification :closable="false">
                <strong>Bemærk!</strong> Hvis du ændrer din email-adresse, skal du bekræfte den igen.
            </b-notification>

            <div class="columns">
                <div class="column">
                    <b-field :label="$t('global.forms.email')" :placeholder="$t('global.forms.email')"
                             :type="{'is-danger': veeErrors.has('email')}"
                             :message="veeErrors.first('email')">
                        <b-input v-model="email" type="email" name="email"
                                 v-validate="emailRules" :data-vv-as="$t('global.forms.email')" />
                    </b-field>
                </div>
                <div class="column">
                    <b-field :label="$t('global.forms.password')" :placeholder="$t('global.forms.password')"
                             :type="{'is-danger': veeErrors.has('password')}"
                             :message="veeErrors.first('password')">
                        <b-input v-model="password" type="password" name="password"
                                 v-validate="passwordRules" :data-vv-as="$t('global.forms.password')" password-reveal />
                    </b-field>
                </div>
            </div>

            <b-notification v-if="error" :active.sync="error" type="is-danger">
                {{error}}
            </b-notification>

            <b-notification v-else-if="success" :active.sync="success" type="is-success">
                {{success}}
            </b-notification>

            <button v-else type="submit" class="button is-primary" :class="{'is-loading': isSubmitting}"
                    :disabled="veeErrors.any() || (this.passwordRules === '' && this.emailRules === '')">
                {{$t('global.actions.update')}}
            </button>
        </form>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import UserService from '@/taskflex/users/services/UserService';

    export default {
        data() {
            return {
                email: null,
                password: null,
                success: null,
                error: null,
                isSubmitting: false,
            };
        },

        computed: {
            ...mapGetters('auth', [
                'currentUser',
            ]),

            emailRules() {
                return (this.email !== this.currentUser.email) ? 'required|email' : '';
            },

            passwordRules() {
                return (this.password) ? 'required|min:8' : '';
            },
        },

        mounted() {
            this.email = this.currentUser.email;
        },

        methods: {
            async submit() {
                if (this.passwordRules === '' && this.emailRules === '') {
                    return;
                }

                if (!await this.$validator.validateAll()) {
                    return;
                }

                const options = {
                    email: this.email,
                    password: this.password,
                };

                this.isSubmitting = true;

                UserService.update(this.currentUser.id, options, () => {
                    this.isSubmitting = false;

                    this.success = 'Dine login oplysninger er nu ændret og du kan logge ind med dem.';
                }, ({ response }) => {
                    this.isSubmitting = false;

                    switch (response.status) {
                        case 422:
                            this.error = 'Denne email er allerede i brug.';
                            break;

                        default:
                            this.error = 'Vi kunne ikke ændre dine oplysninger. Prøv venligst igen.';
                            break;
                    }
                });
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/users/components/EmailPasswordArea.vue